import React from "react";
export function PlaceholderTag({
  children = "Placeholder"
}: {
  children?: React.ReactNode;
}) {
  return <span className="inline-flex items-center gap-1.5 rounded-full border border-dashed border-amber-300/40 bg-amber-300/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-amber-200" data-id="element-477" data-mp="1goa1mcmn01ux">
      {children}
    </span>;
}